import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class InvoiceUploaderService {
    constructor() {}

    getInvoiceUploader$(): Observable<{}> {
        return of({});
    }

}
